// ─────────────────────────────────────────────────────────────────────────────
// PsyPractice — hukuki belgelerin DİLDEN BAĞIMSIZ parçaları.
//
// Belge metinleri dil başına ayrı dosyadadır (./en.ts, ./tr.ts, …) ve hepsi
// buradaki sürümü, türleri ve satıcı kimliğini paylaşır. Bir dil eklemek tek bir
// dosya yazıp ./index.ts kaydına satır eklemektir; bu dosyaya dokunulmaz.
//
// Metinler TEMEL STANDART olarak AB GDPR (2016/679) esas alınarak; Türkiye'deki
// kullanıcılar için KVKK (özellikle yurt dışı aktarım — md. 9) eklenerek; ayrıca
// barındırmanın AB'de (Hollanda / Oracle Cloud) olduğu ve AI işlemenin Anthropic'e
// (gerektiğinde SCC ile AB/AEA dışına) aktarıldığı gerçeği yansıtılarak; sorumluluk
// tamamen Kullanıcıya ait olacak ve klinik-hukuki sorumluluk reddi vurgulu olacak
// şekilde hazırlanmıştır.
//
// ⚠️ SÖZCÜK KURALI: Bu belgelerdeki hiçbir kullanıcıya dönük metin ürünü bir "eğitim",
// "kurs", "sertifika" ("training", "course", "certificate") hizmeti gibi tanımlamaz.
// Gerekçe vergiseldir: bu vokabüler ürünü eğitim hizmeti saydırıp GVK 89/1-13 kazanç
// indirimini bakanlık izni şartına bağlama riski doğurur. Ürün bir YAZILIM aracıdır;
// tek istisna, Mesafeli Satış ve Kullanım Koşullarındaki açık OLUMSUZLAMA cümlesidir.
//
// ⚠️ TASLAK: Yürürlüğe alınmadan önce bir avukat / KVKK uyum danışmanı gözden geçirmeli.
// ─────────────────────────────────────────────────────────────────────────────

export const LEGAL_VERSION = "2026-11-02";

export interface LegalSection {
  heading?: string;
  paras?: string[];
  bullets?: string[];
}

export interface LegalDoc {
  id: string; // footer & deep-link anchor (örn. /legal#terms)
  title: string;
  description: string;
  updated: string;
  sections: LegalSection[];
}

// ── Satıcı / Merchant kimliği ─────────────────────────────────────────────────
// iyzico başvurusu, Mesafeli Satış Sözleşmesi ve Hakkımızda sayfası için yasal
// olarak zorunlu satıcı bilgileri. TEK DOĞRU KAYNAK burasıdır — Hakkımızda,
// Mesafeli Satış ve Teslimat/İade belgelerinin tamamı bu sabitten okur; resmî
// şahıs işletmesi bilgileri netleşince yalnızca aşağıdaki alanlar güncellenir.
export const MERCHANT = {
  brand: "PsyPractice",
  legalName: "Mertcan Aykul",
  // ⚠️ Bu alan işletme TÜRÜNÜ içermez. Eskiden "Mertcan Aykul (sole proprietorship)"
  // idi ve belgeler onu `${legalNameEn} (${typeEn})` kalıbıyla bastığı için tür iki
  // kez yazılıyordu: "Mertcan Aykul (sole proprietorship) (Sole proprietorship)".
  // Ad ile tür ayrı durur; türü her dil kendi dosyasında yazar.
  legalNameEn: "Mertcan Aykul",
  // İşletme türünün adı burada DEĞİL: dile bağlı bir etiket, dilden bağımsız
  // resmî bilgilerin arasında duramaz. Her dil kendi dosyasında OWNER_TYPE yazar
  // (backend'deki karşılığı backend/i18n/<dil>.py → MERCHANT_LABELS["type"]).
  // Vergi dairesine bildirilmiş MERKEZ ADRESİ. E-ticaret yönetmeliği m.5 bunu
  // ana sayfada "iletişim" başlığı altında doğrudan ulaşılabilir şekilde ister;
  // Mesafeli Sözleşmeler Yönetmeliği m.5 de ön bilgilendirmede açık adres arar.
  // ⚠️ ÖNCELİKLİ: bu şu an konut adresidir. Fethiye/Muğla içinde bir sanal ofise
  // geçilip kayıtlı adres taşındığında burası ve backend/merchant.py birlikte
  // güncellenecek (il dışına çıkmamak önemli: özelgeyi Muğla Defterdarlığı verdi).
  address: "Akarca Mah. 894 (AKR) Sk. No: 16/2, Fethiye / Muğla, Türkiye",
  addressEn: "Akarca Mah. 894 (AKR) Sk. No: 16/2, Fethiye / Muğla, Türkiye",
  taxOffice: "Fethiye Vergi Dairesi",
  taxNo: "1220413958",
  email: "info@psycora.com",
  // ⚠️ ÖNCELİKLİ: bu kişisel numaradır, geçici çözümdür. Bulut santral numarası
  // alınınca burası, backend/merchant.py ve landing/index.html birlikte güncellenir.
  phone: "+90 542 328 70 12",
  website: "https://psypractice.psycora.com",
};
